import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react';

import Portal from 'topmeteo/general/components/Portal';

const NotificationContext = createContext(null);

export const useSetNotification = () => {
    const {setNotification} = useContext(NotificationContext);

    return setNotification;
};

const {Provider} = NotificationContext;

export const NotificationProvider = ({children}) => {
    const [notification, setNotification] = useState(null);
    const context = useMemo(() => ({notification, setNotification}), [notification, setNotification]);

    return (
        <Provider value={context}>
            {children}
        </Provider>
    );
};

const useOpacityAnimation = (show, after) => {
    const [opacity, setOpacity] = useState(0);

    useEffect(
        () => {
            if (show) {
                const opacityTimer = setTimeout(() => setOpacity(1), 50);
                const hideTimer = setTimeout(() => setOpacity(0), 3050);
                const finishedTimer = setTimeout(after, 4050);

                return () => {
                    clearTimeout(opacityTimer);
                    clearTimeout(hideTimer);
                    clearTimeout(finishedTimer);
                };
            }
        },
        [show, after],
    );

    return opacity;
};

const Notification = () => {
    const {notification, setNotification} = useContext(NotificationContext);
    const removeNotification = useCallback(() => setNotification(null), [setNotification]);
    const opacity = useOpacityAnimation(notification, removeNotification);

    return notification && (
        <Portal container="map-wrapper">
            <div className="export-notification" style={{opacity}}>
                <p>{notification}</p>
            </div>
        </Portal>
    );
};

export default Notification;
